import React from 'react'
import styled from 'styled-components'
import VersionsIcon from '../../../Icons/Versions/Versions'
import { Black } from '../../../../Constants/ColorChart'
import FeatherIconWrapper from "../../../Icons/FeatherIconWrapper";

/*
 *  @Description:   Stateless component that represents the playlist Icon. Used to show in a Resource header.
 */

const StyledIcon = styled.div`
    border-radius: 9px 9px;
    margin-left: auto;
    margin-right: auto;
    border: 1px solid ${ Black };
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: 992px){
        border: 2px solid ${ Black };
        width: 240px;
        height: 240px;
    }
    @media screen and (min-width: 1200px){
        border: 3px solid ${ Black };
        width: 260px;
        height: 260px;
    }
    @media screen and (min-width: 1600px){
        border: 4px solid ${ Black };
        width: 280px;
        height: 280px;
    }
    @media screen and (min-width: 1800px){
        border: 5px solid ${ Black };
        width: 300px;
        height: 300px;
    }
    .ResourceIcon{
         height: 35px!important; 
         width: 35px!important;
    
        @media (min-width: 768px) {
             height: 40px!important; 
             width: 40px!important;
        }
        
        @media (min-width: 992px) {
             height: 45px!important;
             width: 45px!important;
        }
        
        @media (min-width: 1200px) {
             height: 50px!important;
             width: 50px!important;
        }
        
        @media (min-width: 1600px) { 
             height: 55px!important; 
             width: 55px!important;
        }
        @media (min-width: 1800px) {
             height: 60px!important; 
             width: 60px!important;
        }
    }
    
`;

const ResourceIcon = () => {

    return (
        <StyledIcon>
            <FeatherIconWrapper
                color={ Black }
                className={"ResourceIcon"}
                width={ "35px" }
                Icon={ VersionsIcon }
            />
        </StyledIcon>

    );

}


export default ResourceIcon;